if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"partner","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}